// Globals
import React from 'react';
import { useTranslation } from 'react-i18next';

const HomeContainer = () => {
  const { t } = useTranslation();

  return (
    <div>
      <p style={{ textAlign: 'center', width: '100%' }}>
        {/* eslint-disable-next-line jsx-a11y/alt-text */}
        {t('welcome_greeting')} <img src={'/favicon.ico'} />
      </p>
    </div>
  );
};

export default HomeContainer;
